import React from 'react';
import Input from 'es6/components/registration/inputs/input';
import { t } from 'es6/services/localization';

/**
 * Overrides the error message with out own custom message.
 *
 * @param {Event} e
 */
function checkValidity(e) {
  const { target } = e;
  const { validity } = target;

  // Unset the custom validity error message when the target validates.
  if (validity.customError && !validity.patternMismatch) {
    target.setCustomValidity('');
  } else if (validity.patternMismatch) {
    target.setCustomValidity(t('input.password.pattern-mismatch'));
  }
}

export default function PasswordInput(props) {
  return (
    <Input
      type="password"
      name="user[password]"
      pattern=".{6,}"
      placeholder={t('placeholder.password')}
      required
      onChange={checkValidity}
      onInvalid={checkValidity}
      {...props}
    />
  );
}
